<template>
	<v-dialog v-model="show" max-width="2000" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
		<v-card class="h-86" id="abcdefg">
			<v-card-title class="card-header-add font-weight-bold px-2 py-2">
				<span class="font-size15">{{ $t('patient-daily-measurements-notes') }} {{ patientName }}</span>
				<v-spacer />
				<v-icon color="white" @click="closeDialog()">mdi-window-close</v-icon>
			</v-card-title>
			<v-card-text class="overflow-hidden pa-2" style="height: calc(100% - 48px)">
				<v-row dense style="height: calc(100% + 8px)">
					<v-col cols="12" md="5" class="hp-100">
						<Notes
							:showFiltering="false"
							:patientId="patientId"
							:month="getMonthAndYear().month"
							:year="getMonthAndYear().year"
							@openDrawer="handleDrawer" />
					</v-col>
					<v-col cols="12" md="4" class="hp-100">
						<v-row dense style="height: calc(100% + 8px)">
							<v-col cols="12" class="hp-50" ref="measurementsTable" v-resize="calcMeasurementsTableHeight">
								<v-data-table
									:height="measurementsTableHeight"
									id="table1"
									:items="measurements"
									:headers="headers"
									class="elevation-1"
									fixed-header
									:no-data-text="$t('no-data-available')"
									:loading-text="$t('loading')"
									:footer-props="getDataTableFooterProps('monthlyReviewDialogTable')"
									:items-per-page="-1">
									<template #item="{ item }">
										<tr :class="{ 'chips-icon': item.isAbnormal }">
											<td class="font-size13 font-weight-medium text-left" style="height: 25px !important">
												<div class="d-flex align-center">
													<v-img :src="getDeviceIcons(item)" max-width="20" class="mr-2"></v-img>
													{{ formatDate(item.measuredAtUtc) }}
												</div>
											</td>
											<td class="font-size13 font-weight-medium text-right" style="height: 25px !important">
												{{ formatMeasurement(JSON.parse(item.measuredDataJson)) }}
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-col>
							<v-col cols="12" class="hp-50">
								<v-card>
									<v-card-title class="pa-0 justify-center">
										{{ $t('measurements-from-other-providers') }}
									</v-card-title>
									<v-data-table
										:height="measurementsTableHeight - 32"
										:items="ccmVitalsByMonthByYear"
										:headers="ccmVitalsByMonthByYearHeaders"
										class="elevation-1 pointer"
										id="table2"
										fixed-header
										:no-data-text="$t('no-data-available')"
										:loading-text="$t('loading')"
										:footer-props="getDataTableFooterProps('monthlyReviewDialogTable')"
										:items-per-page="-1">
										<template #item="{ item }">
											<tr>
												<td class="font-size13 font-weight-medium text-left pl-2 pr-0" style="height: 25px !important">
													{{ item.vitalType }}
												</td>
												<td class="font-size13 font-weight-medium text-left pr-0" style="height: 25px !important">
													{{ item.notes }}/{{ item.performedBy }}
												</td>
												<td class="font-size13 font-weight-medium text-left pr-0" style="height: 25px !important">
													{{ item.valueFormatted }} {{ item.unitFormatted }}
												</td>
												<td class="font-size13 font-weight-medium text-left pr-2" style="height: 25px !important">
													<div class="d-flex align-center justify-space-between">
														{{ formatTimestamp(item.vitalDate) }}
														<v-tooltip color="primary" right>
															<template #activator="{ on }">
																<v-icon
																	v-if="item.createMedicalNoteForThisVital"
																	v-on="on"
																	color="primary"
																	dense
																	class="pa-0 ma-0"
																	@click="build3rdPartyVitalEntryMedicalNote(item)">
																	mdi-plus-circle
																</v-icon>
															</template>
															<span> {{ $t('create-note-with-3rd-party-measurement') }} </span>
														</v-tooltip>
													</div>
												</td>
											</tr>
										</template>
									</v-data-table>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" md="3" class="hp-100" style="overflow-y: hidden">
						<v-card class="hp-100">
							<v-card-text class="overflow-hidden hp-100" :key="rerender" ref="notesCard" v-resize="calcTextAreaHeight">
								<v-row dense>
									<v-col cols="12" ref="templateSelect">
										<v-select
											v-model="selectedTemplate"
											:items="medicalNotesCategoriesForHospital"
											item-text="medicalNoteCategoryName"
											item-value="id"
											:label="this.$t('Select-template')"
											outlined
											dense
											hide-details
											auto
											return-object
											:menu-props="{ offsetY: true }"
											@change="getTemplateDescription">
											<template #item="data">
												<div class="d-flex justify-start align-center">
													<span class="font-weight-medium font-size15">{{ data.item.medicalNoteCategoryName }}</span>
												</div>
											</template>
										</v-select>
									</v-col>
									<v-col cols="12" ref="billingsTimeSelect">
										<v-text-field
											outlined
											dense
											hide-details
											v-model="intervalInput"
											readonly
											:label="$t('billings-time')" />
									</v-col>
									<!--  TODO: This is hidden with intension to not manipulate the date! DO NOT REMOVE IT because we use the v-model ! ! !  -->
									<v-col v-if="false" cols="0" class="mt-n4">
										<v-menu
											v-model="menu"
											:close-on-content-click="false"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="290px">
											<template #activator="{ on, attrs }">
												<v-icon color="primary" v-bind="attrs" v-on="on" class="pa-0 my-4 mr-2" @click="menu = !menu">
													mdi-calendar
												</v-icon>
											</template>
											<v-date-picker
												@change="dateSelected"
												v-model="calendarDate"
												@input="menu = false"></v-date-picker>
										</v-menu>
									</v-col>
									<v-col v-if="false" cols="0" class="mt-n4">
										<v-menu
											v-model="menu"
											:close-on-content-click="false"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
											min-width="290px">
											<template #activator="{ on, attrs }">
												<v-icon color="primary" v-bind="attrs" v-on="on" class="pa-0 my-4 mr-2" @click="menu = !menu">
													mdi-calendar
												</v-icon>
											</template>
											<v-date-picker
												@change="dateSelected"
												v-model="calendarDate"
												@input="menu = false"></v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="12">
										<v-textarea
											hide-details
											dense
											class="font-size12-5 elevation-0"
											solo
											no-resize
											v-model="medicalNote"
											:height="textAreaHeight">
										</v-textarea>
									</v-col>
									<v-col cols="6" ref="commentEditToggle">
										<v-card class="elevation-0">
											<div class="py-0 my-0 d-flex flex-column justify-center">
												<span class="font-weight-bold color-black font-size12-5">
													{{ $t('allow-others-to-comment') }}
												</span>
												<v-btn-toggle
													v-model="commentedFromOthers"
													row
													active-class="chips white--text"
													mandatory
													class="white">
													<v-btn x-small :value="true" :input-value="commentedFromOthers" width="50%">
														{{ $t('yes') }}
													</v-btn>
													<v-btn x-small :value="false" :input-value="commentedFromOthers" width="50%">
														{{ $t('no') }}
													</v-btn>
												</v-btn-toggle>
											</div>
										</v-card>
									</v-col>
									<v-col cols="6">
										<v-card class="d-flex flex-column elevation-0">
											<div class="py-0 my-0 d-flex flex-column justify-center">
												<span class="font-weight-bold color-black font-size12-5">{{ $t('allow-others-to-edit') }}</span>
												<v-btn-toggle
													v-model="editedFromOthers"
													row
													active-class="chips white--text"
													mandatory
													class="white">
													<v-btn x-small :value="true" :input-value="editedFromOthers" width="50%">
														{{ $t('yes') }}
													</v-btn>
													<v-btn x-small :value="false" :input-value="editedFromOthers" width="50%">
														{{ $t('no') }}
													</v-btn>
												</v-btn-toggle>
											</div>
										</v-card>
									</v-col>
									<v-col cols="12" ref="saveButton" class="text-right">
										<v-btn
											:disabled="!selectedTemplate"
											small
											class="ml-auto mt-2"
											color="chips"
											style="text-transform: capitalize; width: 90px; color: white"
											:ripple="false"
											elevation="0"
											@click="synchronizeDrawersV2('addNote')">
											+ {{ $t('save') }}
										</v-btn>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import {
	bloodPressureBlack,
	glucoseMeterBlack,
	monitoringPlanBlack,
	oxymeterBlack,
	scaleBlack,
	thermometerBlack,
	wellnessAssessmentBlack,
} from '@/assets';
import {
	getDataTableFooterProps,
	showErrorAlert,
	showSuccessAlert,
	formatTimestamp,
	getValueByUnit,
} from '@/utils/utilities';
import Notes from '@/views/Client/components/Notes.vue';

export default {
	name: 'MonthlyReviewDialog',
	components: { Notes },
	data () {
		return {
			secondsToBill: 0,
			intervalInput: '',
			secondsInterval: null,
			billingsSecondsTextFieldVisible: false,
			wellnessIcon: wellnessAssessmentBlack,
			oximeterIcon: oxymeterBlack,
			glucoseIcon: glucoseMeterBlack,
			bloodPressureIcon: bloodPressureBlack,
			thermometerIcon: thermometerBlack,
			weightScaleIcon: scaleBlack,
			MonitoringPLanBlack: monitoringPlanBlack,
			menu: false,
			onMedication: true,
			calendarDate: new Date().toISOString().slice(0, 10), // Default date
			selectedTemplate: null,
			selectedMedicalNoteCategory: null,
			medicalNote: '',
			rerender: 1,
			selectedTemplateId: 1,
			commentedFromOthers: true,
			editedFromOthers: false,
			medicalNoteEmpty: true,
			isLoading: false,
			billingSecondsForThisMedicalNoteCategory: null,
			medicalNoteCategoryName: null,
			measurementsByDeviceType: {},
			formatedReport: null,
			medicalNoteNameAdditionalData: '',
			medicalNoteStartDate: null,
			medicalNoteEndDate: null,
			assignedHospitalId: null,
			sendMail: false,
			showCheckboxForEmail: false,
			dailyMedicalNotes: [],
			sortBy: 'noteTimestamp',
			sortDesc: true,
			search: '',
			loading: false,
			noteHeaders: [
				{ text: this.$t('staff'), class: 'table-header height15-black', sortable: false, align: 'start pl-2' },
				{ text: this.$t('note-description'), class: 'table-header height15-black', sortable: false, align: 'start' },
			],
			noteHeaders1: [
				{ text: this.$t('MedicalNote'), class: 'table-header height15-black', sortable: false, align: 'start pl-2' },
				{ text: this.$t('created'), class: 'table-header height15-black ', sortable: false, align: 'end pr-5' },
			],
			selectedCCMRecord: null,
			ccmVitalsByMonthByYear: [],
			measurementsTableHeight: 300,
			textAreaHeight: 300,
			startTime: new Date().getTime(),
		};
	},
	props: {
		show: {
			type: Boolean,
			required: true,
		},
		patientObject: {
			type: Object,
			required: true,
		},
		patientId: {
			type: Number,
			required: true,
		},
		dialogType: {
			type: String,
			required: true,
		},
		selectedDate: {
			type: String,
			required: true,
		},
		startDate: {
			type: String,
			required: false,
		},
		endDate: {
			type: String,
			required: false,
		},
		patientName: {
			type: String,
			required: true,
		},
		measurements: {
			type: Array,
			required: true,
		},
		medicalNotes: {
			type: Array,
			required: true,
		},
		medicalNoteNewToRPM: {
			type: Array,
			required: true,
		},
		medicalNoteMedicationChange: {
			type: Array,
			required: true,
		},
		measurementsFrom3rdParty: {
			type: Array,
			required: true,
		},
		deviceDefaultsValues: {
			type: Array,
			required: true,
		},
	},
	computed: {
		...mapGetters({
			pageHeight: 'pageHeight',
			userSettings: 'authentication/getUserSettings',
		}),
		...mapState({
			medicalStaff: (state) => state.hospitals.medicalStaff,
			userData: (state) => state.authentication.userData,
			updateDrawer: (state) => state.updateDrawer,
			filter: (state) => state.filter,
			hubs: (state) => state.medicaldevice.hubs,
			ccmRecordsByPatientId: (state) => state.ccmRecords.ccmRecordsByPatientId,
			notesFromRepo: (state) => state.appointments.notes,
		}),
		// eslint-disable-next-line vue/return-in-computed-property
		medicalNotesCategoriesForHospital () {
			let allowedTypes = [];

			// Specify the types you want to include based on dialogType
			switch (this.dialogType) {
				case 'DAILY':
					allowedTypes = [
						'MN-3RDS',
						'MN-GENERAL',
						'MN-NO-READING',
						'MN-ABNORMAL-READING',
						'MN-NORMAL-READING',
						'MN-DRUGS',
						'MN-HOSPITAL',
						'MN-PHONE-COMMUNICATION',
					];
					break;
				case 'W1':
				case 'W2':
				case 'W3':
				case 'W4':
					allowedTypes = [
						'RPM-WEEKLY-SUMMARY-MN-BLOOD-PRESSURE',
						'RPM-WEEKLY-SUMMARY-MN-BLOOD-SUGAR',
						'MN-WEEKLY-NORMAL',
						'MN-WEEKLY-ABNORMAL',
					];
					break;
				case 'MONTHLY':
					// allowedTypes = ['MN-MONTHLY', 'MN-NEW-RPM'];
					allowedTypes = ['RPM-MONTHLY-SUMMARY-MN-BLOOD-PRESSURE', 'RPM-MONTHLY-SUMMARY-MN-BLOOD-SUGAR', 'MN-MONTHLY'];
					break;
				// Add more cases here if needed
				default:
					// Default case if dialogType doesn't match any of the specified cases
					allowedTypes = [];
					break;
			}

			// Filter medical note categories based on allowedTypes
			return this.$store.state.medicalnotecategory.medicalNotesCategoriesForHospital.filter((noteCategory) => {
				return allowedTypes.includes(noteCategory.medicalNoteCategoryType);
			});
		},
		headers () {
			return [
				{ text: this.$t('time'), value: 'measuredAtUtc', sortable: false, class: 'table-header text-start pl-5' },
				{ text: this.$t('measurements'), value: 'measuredDataJson', class: 'table-header text-end pl-4' },
				// { text: '', value: '', class: 'table-header pr-7', align: 'end', sortable: false, width: 50 },
			];
		},
		ccmVitalsByMonthByYearHeaders () {
			return [
				{ text: this.$t('vital-type'), value: 'vitalType', sortable: true, class: 'pl-2 pr-0' },
				{ text: this.$t('from/by'), value: 'notes', sortable: true, class: 'pr-0' },
				{ text: this.$t('value'), value: 'value', sortable: true, class: 'pr-0' },
				{ text: this.$t('vital') + ' ' + this.$t('date'), value: 'vitalDate', sortable: true, class: 'pr-2' },
			];
		},
	},
	async mounted () {
		this.calendarDate = this.selectedDate;
		this.getAllMedicalStaff();
		this.assignedHospitalId = localStorage.getItem('selectedHospitalAssignedId');
		this.$store.dispatch('medicalnotecategory/medicalnotecategorytemplateforhospital', this.assignedHospitalId);

		this.loadVitalEntries();
		this.calcMeasurementsTableHeight();
		this.calcTextAreaHeight();
		this.secondsInterval = setInterval(this.updateSeconds, 1000);
	},
	beforeDestroy () {
		clearInterval(this.secondsInterval);
	},
	watch: {
		async patientObject () {
			await this.storeCCMRecordsByPatientId(this.patientObject.patientId);
			this.loadVitalEntries();
		},
		secondsToBill (val) {
			const mins = Math.floor(val / 60);
			const secs = val % 60;
			this.intervalInput = `${mins}:${secs.toString().padStart(2, '0')}`;
		},
		show: {
			handler (newVal) {
				this.calendarDate = this.selectedDate;
				if (newVal) {
					this.assignedHospitalId = localStorage.getItem('selectedHospitalAssignedId');
					this.$store.dispatch('medicalnotecategory/medicalnotecategorytemplateforhospital', this.assignedHospitalId);
				}
			},
			deep: true,
		},
		measurementsFrom3rdParty (measurementsFrom3rdParty) {
			this.measurementsFrom3rdParty = measurementsFrom3rdParty;
			this.updateDailyMedicalNotes();
		},
		medicalNoteMedicationChange (medicalNoteMedicationChange) {
			this.medicalNoteMedicationChange = medicalNoteMedicationChange;
			this.updateDailyMedicalNotes();
		},
		medicalNotes (medicalNote) {
			this.medicalNotes = medicalNote;
			this.updateDailyMedicalNotes();
		},
		medicalNoteNewToRPM (medicalNoteNewToRPM) {
			this.medicalNoteNewToRPM = medicalNoteNewToRPM;
			this.updateDailyMedicalNotes();
		},
	},

	methods: {
		...mapActions({
			stopTrackingWithPatientV2: 'timetracking/stoptrackingwithpatientV2',
			storeCCMRecordsByPatientId: 'ccmRecords/storeMinimalCCMRecordsByPatientId',
			getCCMVitalEntriesByPatientIdByMonthByYear: 'ccmVitalEntry/getCCMVitalEntriesByPatientIdByMonthByYear',
			disableMedicalNoteForThisVitalEntry: 'ccmVitalEntry/disableMedicalNoteForThisVitalEntry',
		}),
		handleDrawer () {
			this.$store.commit('SET_TOGGLE_REVIEW_DIALOG', false);
		},
		async build3rdPartyVitalEntryMedicalNote (vitalEntry) {
			const {
				patientName,
				hospitalName,
				vitalDate,
				vitalType,
				value,
				performedBy,
				dataSupplyProviderName,
				referenceId,
			} = vitalEntry;

			// format date into readable string
			const dateStr = new Date(vitalDate).toLocaleString('en-US', {
				timeZone: 'UTC',
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

			const date = new Date(vitalEntry.vitalDate);
			const formatter = new Intl.DateTimeFormat('en-CA'); // ISO-like format yyyy-MM-dd
			const dateTime = formatter.format(date);
			const medicalNote = `${vitalType} (${value}) recorded in ${hospitalName}’s electronic medical record for ${patientName} on ${dateStr} UTC. 
                            The ${vitalType.toLowerCase()} reading was reviewed; we will continue to monitor and update the PCP as needed. 
                            A reminder was sent to the facility to obtain daily vital readings within Wellness Metrics. 
                            (Performed by: ${performedBy}; Source: ${dataSupplyProviderName}; Ref ID: ${referenceId}.)`;

			var selectedMedicalNoteCategory = this.medicalNotesCategoriesForHospital.find(
				(item) => item.medicalNoteCategoryType === 'MN-3RDS',
			);

			if (!selectedMedicalNoteCategory) {
				showErrorAlert(this.$t('missing-template-or-not-assign-to-this-location'));
				return;
			}
			const totalTime = new Date().getTime() - this.startTime;
			const payloadBody = {
				medicalNoteName: selectedMedicalNoteCategory.medicalNoteCategoryName + ': ' + dateTime,
				medicalNoteCategoryId: selectedMedicalNoteCategory.id,
				medicalNoteOfficeId: localStorage.getItem('selectedHospitalAssignedId'),
				createdByMedicalStaffId: this.userData.id,
				medicalNoteForPatientId: this.patientId,
				medicalNoteStartDate: dateTime,
				medicalNoteEndDate: dateTime,
				allowToBeEditedFromOthers: false,
				allowToBeCommentedFromOthers: true,
				// secondsToBill: selectedMedicalNoteCategory.billingSecondsForThisMedicalNoteCategory,
				secondsToBill: Math.floor(totalTime / 1000),
				medicalNoteDetail: {
					medicalStaffId: this.userData.id,
					medicalNoteContent: medicalNote,
					medicalNoteAdditionalData: '',
				},
			};

			// Add medical note
			await this.$store.dispatch('appointments/medicalNoteWithCustomSeconds', payloadBody).then((res) => {
				// Disable the + icon from teh db
				this.disableMedicalNoteForThisVitalEntry(vitalEntry.id).then((res) => {
					// Reload the mesurements
					this.loadVitalEntries();
					// Reload the medical notes
					const body = {
						patientId: this.$route.params.id || this.patientId,
						hospitalId: localStorage.getItem('selectedHospitalAssignedId'),
						month: this.getMonthAndYear().month,
						year: this.getMonthAndYear().year,
					};
					this.$store.dispatch('appointments/getmedicalnoteforpatientbyidByMonthYear', body).then((res) => {
						this.loading = false;
						this.toggleHeaders();
					});
				});
			});
			this.startTime = new Date().getTime();
		},
		formatTimestamp,
		updateSeconds () {
			const timeSpent = new Date().getTime() - this.startTime;
			const totalSeconds = Math.floor(timeSpent / 1000);
			const hh = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
			const mm = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
			const ss = String(totalSeconds % 60).padStart(2, '0');
			this.intervalInput = `${hh}:${mm}:${ss}`;
		},
		getDataTableFooterProps,
		checkIfiCanDeleteMedicalNote (medicalNoteData) {
			return (
				medicalNoteData.createdByMedicalStaffId === this.userData.id && medicalNoteData.medicalNoteDetails.length < 2
			);
		},
		checkIfiCanDeleteAdditionalNote (medicalNoteDetailData) {
			return medicalNoteDetailData.medicalStaffId === this.userData.id;
		},

		async deleteMedicalNote (val) {
			const id = val.id;
			try {
				const res = await this.$store.dispatch('appointments/deleteMedicalNote', id);
				if (res) {
					// TODO delete this from local master records
					const index = this.dailyMedicalNotes.findIndex((item) => item.medicalNoteData.id === id);
					if (index !== -1) {
						this.dailyMedicalNotes.splice(index, 1);
					}
					showSuccessAlert(this.$t('success-operation'));
					this.$emit('reload-medical-notes');
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
			} catch (error) {
				if (error.response && error.response.status === 404) {
					showErrorAlert(error.response.data.msg);
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
			}
		},

		getDeviceIcons (device) {
			switch (device.deviceType) {
				case 5:
					return this.weightScaleIcon;
				case 3:
					return this.bloodPressureIcon;
				case 2:
					return this.oximeterIcon;
				case 1:
					return this.thermometerIcon;
				case 6:
					return this.glucoseIcon;
			}
		},
		updateDailyMedicalNotes () {
			this.dailyMedicalNotes = [];

			if (this.medicalNotes.length > 0) {
				this.dailyMedicalNotes = this.dailyMedicalNotes.concat(this.medicalNotes);
			}

			if (this.measurementsFrom3rdParty.length > 0) {
				this.dailyMedicalNotes = this.dailyMedicalNotes.concat(this.measurementsFrom3rdParty);
			}

			if (this.medicalNoteMedicationChange.length > 0) {
				this.dailyMedicalNotes = this.dailyMedicalNotes.concat(this.medicalNoteMedicationChange);
			}

			if (this.medicalNoteNewToRPM.length > 0) {
				this.dailyMedicalNotes = this.dailyMedicalNotes.concat(this.medicalNoteNewToRPM);
			}
			this.delayExecution(500);
		},
		composeReport (val) {
			switch (val.medicalNoteCategoryType) {
				// Daily medical review Normal reading  DAILY
				case 'MN-NORMAL-READING':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					this.createNormalDailyReview();
					break;
				// Daily medical review Abnormal reading  DAILY
				case 'MN-ABNORMAL-READING':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					this.createAbnormalDailyReview();
					break;
				// Daily medical review No reading DAILY
				case 'MN-NO-READING':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					// this.medicalNoteStartDate = this.firstDayOfSelectedMonth();
					// this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					// this.createDailyReviewWithMeasurements();
					this.createNoReadingReview();
					break;
				// Weekly medical review  WEEKLY (Normal)
				case 'MN-WEEKLY-NORMAL':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					this.medicalNoteNameAdditionalData =
						this.formatDateToUS(this.medicalNoteStartDate.toString()) +
						'-' +
						this.formatDateToUS(this.medicalNoteEndDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					this.createWeeklyNormalReview();
					break;
				// Weekly medical review  WEEKLY (Abnormal)
				case 'MN-WEEKLY-ABNORMAL':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					// this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					// this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData =
						this.formatDateToUS(this.medicalNoteStartDate.toString()) +
						'-' +
						this.formatDateToUS(this.medicalNoteEndDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithoutArguments();
					this.createWeeklyAbnormalReview();

					break;
				case 'RPM-WEEKLY-SUMMARY-MN-BLOOD-PRESSURE':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					// this.medicalNoteStartDate = this.firstDayOfSelectedMonth();
					// this.medicalNoteEndDate = this.lastDayOfSelectedMonth(new Date(this.calendarDate)); // new Date(this.calendarDate).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData =
						this.formatDateToUS(this.medicalNoteStartDate.toString()) +
						'-' +
						this.formatDateToUS(this.medicalNoteEndDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					this.createRpmWeeklySummaryBloodPressure();
					break;

				case 'RPM-WEEKLY-SUMMARY-MN-BLOOD-SUGAR':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					// this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					// this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData =
						this.formatDateToUS(this.medicalNoteStartDate.toString()) +
						'-' +
						this.formatDateToUS(this.medicalNoteEndDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithoutArguments();
					this.createRpmWeeklySummaryBloodSugar();

					break;
				// Monthly medical review  MONTHLY
				case 'MN-MONTHLY':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					// this.medicalNoteStartDate = this.firstDayOfSelectedMonth();
					// this.medicalNoteEndDate = this.lastDayOfSelectedMonth(new Date(this.calendarDate)); // new Date(this.calendarDate).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatMonthAndYear(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					this.createMonthlyReview();
					break;
				case 'RPM-MONTHLY-SUMMARY-MN-BLOOD-PRESSURE':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					// this.medicalNoteStartDate = this.firstDayOfSelectedMonth();
					// this.medicalNoteEndDate = this.lastDayOfSelectedMonth(new Date(this.calendarDate)); // new Date(this.calendarDate).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatMonthAndYear(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					// this.createFormatReportWithMeasurements();
					this.createRpmMonthlySummaryBloodPressure();
					break;
				case 'RPM-MONTHLY-SUMMARY-MN-BLOOD-SUGAR':
					this.medicalNoteStartDate = this.startDate;
					this.medicalNoteEndDate = this.endDate;
					// this.medicalNoteStartDate = this.firstDayOfSelectedMonth();
					// this.medicalNoteEndDate = this.lastDayOfSelectedMonth(new Date(this.calendarDate)); // new Date(this.calendarDate).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatMonthAndYear(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					this.createRpmMonthlySummaryBloodSugar();
					break;

				// Medical Note New to RPM services
				case 'MN-NEW-RPM':
					this.medicalNoteStartDate = this.firstDayOfSelectedMonth();
					this.medicalNoteEndDate = this.lastDayOfSelectedMonth(new Date(this.calendarDate)); // new Date(this.calendarDate).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					this.createNewToRpmReview();
					// this.createFormatReportWithoutArguments();
					break;
				// General medical note  DAILY
				case 'MN-GENERAL':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.createFormatReportWithoutArguments();
					break;
				// Measurement read from 3rd party system DAILY
				case 'MN-3RDS':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.generateReport(this.medicalNoteStartDate, this.medicalNoteEndDate, val.medicalNoteCategoryType);
					this.thirdPartyReport();
					break;
				case 'MN-DRUGS':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.createFormatReportWithoutArguments();
					break;
				// Medical Note In Hospital
				case 'MN-HOSPITAL':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.createFormatReportWithoutArguments();
					break;
				case 'MN-PHONE-COMMUNICATION':
					this.medicalNoteStartDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteEndDate = new Date(this.calendarDate.toString()).toISOString().slice(0, 10);
					this.medicalNoteNameAdditionalData = this.formatDateToUS(this.medicalNoteStartDate.toString());
					this.createFormatReportPhoneComunication();
					break;
			}
		},
		formatMonthAndYear (date) {
			// Get the year
			const [year, month] = date.split('-');
			// Return the formatted string
			return `${month}, ${year}`;
		},
		lastDayOfSelectedMonth (date) {
			const today = new Date();
			const year = date.getFullYear();
			const month = date.getMonth();

			// Set the date to the last day of the selected month
			const lastDay = new Date(year, month + 1, 1);

			// Check if today's date is after the last day of the selected month
			if (today > lastDay) {
				// If it is, return the last day of the selected month
				return lastDay.toISOString().slice(0, 10);
			} else {
				// Otherwise, return today's date
				return today.toISOString().slice(0, 10);
			}
		},
		getMeasurementsByDeviceType (deviceTypeId) {
			return this.measurementsByDeviceType[deviceTypeId] || null;
		},
		createNormalDailyReview () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);

			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data) {
					thereIsNoData = true;
					const tempCounts = data.count;
					const tempMax = data.extremes.maxValue.readableFormat;
					const tempMin = data.extremes.minValue.readableFormat;
					const formatted = selectedTemplate.medicalNoteCategoryDescription
						.replace('[DEVICE-MEASUREMENT-UNIT]', this.formatMeasurementName(deviceType))
						.replace('[MEASUREMENT-COUNT]', tempCounts)
						.replace('[MAX]', tempMax)
						.replace('[MIN]', tempMin);

					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}

			this.medicalNote = this.formatedReport;
		},
		// createNormalDailyReviewOld () {
		//   this.formatedReport = '';
		//
		//   // Find the selected template
		//   const selectedTemplate = this.medicalNotesCategoriesForHospital.find(item => item.id === this.selectedTemplate.id);
		//   this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;
		//
		//   // Initialize default placeholder values
		//   let tempCounts = '[MEASUREMENT-COUNT]';
		//   let tempBPMMax = '[BPM-MAX]';
		//   let tempBPMMin = '[BPM-MIN]';
		//
		//   tempCounts = 0;
		//   tempBPMMax = '';
		//   tempBPMMin = '';
		//
		//   if (this.measurementsByDeviceType.length > 0 && this.measurementsByDeviceType[3]) {
		//     // for (const deviceType in this.measurementsByDeviceType) {
		//     const { count, extremes } = this.measurementsByDeviceType[3];
		//     tempCounts = count;
		//     tempBPMMax = extremes.maxValue.readableFormat;
		//     tempBPMMin = extremes.minValue.readableFormat;
		//     // }
		//   }
		//
		//   // Replace placeholders in the template
		//   this.formatedReport = this.formatedReport
		//       .replace('[MEASUREMENT-COUNT]', tempCounts)
		//       .replace('[BPM-MAX]', tempBPMMax)
		//       .replace('[BPM-MIN]', tempBPMMin);
		//
		//   // Assign the final report to the medicalNote
		//   this.medicalNote = this.formatedReport;
		// },
		createAbnormalDailyReview () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);

			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data) {
					thereIsNoData = true;
					const tempCounts = data.count;
					const tempMax = data.extremes.maxValue.readableFormat;
					const tempMin = data.extremes.minValue.readableFormat;

					const formatted = selectedTemplate.medicalNoteCategoryDescription
						.replace('[DEVICE-MEASUREMENT-UNIT]', this.formatMeasurementName(deviceType))
						.replace('[MEASUREMENT-COUNT]', tempCounts)
						.replace('[MAX]', tempMax)
						.replace('[MIN]', tempMin);

					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}

			this.medicalNote = this.formatedReport;
		},
		createNoReadingReview () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data && data.measurements.length > 0) {
					thereIsNoData = true;
					const tempCounts = data.count;
					const tempMax = data.extremes.maxValue.readableFormat;
					const tempMin = data.extremes.minValue.readableFormat;
					const lastMeasuredDateTime = data.measurements[0].measuredAtLocalTime;

					const formatted = selectedTemplate.medicalNoteCategoryDescription
						.replace('[DEVICE-MEASUREMENT-UNIT]', this.formatMeasurementName(deviceType))
						.replace('[MEASUREMENT-COUNT]', tempCounts)
						.replace('[SINCE-DAYS]', lastMeasuredDateTime)
						.replace('[MAX]', tempMax)
						.replace('[MIN]', tempMin);

					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}
			this.medicalNote = this.formatedReport;
		},
		// createNoReadingReviewOld () {
		//   this.formatedReport = '';
		//
		//   // Find the selected template
		//   const selectedTemplate = this.medicalNotesCategoriesForHospital.find(item => item.id === this.selectedTemplate.id);
		//   this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;
		//
		//   // Initialize default placeholder values
		//   let tempCounts = '[MEASUREMENT-COUNT]';
		//   let tempBPMMax = '[BPM-MAX]';
		//   let tempBPMMin = '[BPM-MIN]';
		//   let lastMeasuredDateTime = '[SINCE-DAYS]';
		//
		//   tempCounts = 0;
		//   tempBPMMax = '';
		//   tempBPMMin = '';
		//
		//   if (this.measurementsByDeviceType.length > 0 && this.measurementsByDeviceType[3]) { // for (const deviceType in this.measurementsByDeviceType) {
		//     const { count, extremes, measurements } = this.measurementsByDeviceType[3];
		//     lastMeasuredDateTime = measurements[0].measuredAtLocalTime;
		//     tempCounts = count;
		//     tempBPMMax = extremes.maxValue.readableFormat;
		//     tempBPMMin = extremes.minValue.readableFormat;
		//   }
		//   // }
		//
		//   // Replace placeholders in the template
		//   this.formatedReport = this.formatedReport
		//       .replace('[MEASUREMENT-COUNT]', tempCounts)
		//       .replace('[SINCE-DAYS]', lastMeasuredDateTime)
		//       .replace('[BPM-MAX]', tempBPMMax)
		//       .replace('[BPM-MIN]', tempBPMMin);
		//
		//   // Assign the final report to the medicalNote
		//   this.medicalNote = this.formatedReport;
		// },
		createWeeklyNormalReview () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);

			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data && data.measurements.length > 0) {
					thereIsNoData = true;
					const tempCounts = data.count;
					const tempMax = data.extremes.maxValue.readableFormat;
					const tempMin = data.extremes.minValue.readableFormat;
					const lastMeasuredDateTime = data.measurements[0].measuredAtLocalTime;

					const formatted = selectedTemplate.medicalNoteCategoryDescription
						.replace('[DEVICE-MEASUREMENT-UNIT]', this.formatMeasurementName(deviceType))
						.replace('[MEASUREMENT-COUNT]', tempCounts)
						.replace('[SINCE-DAYS]', lastMeasuredDateTime)
						.replace('[MAX]', tempMax)
						.replace('[MIN]', tempMin);

					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}

			this.medicalNote = this.formatedReport;
		},
		// createWeeklyNormalReviewOld () {
		//   this.formatedReport = '';
		//
		//   // Find the selected template
		//   const selectedTemplate = this.medicalNotesCategoriesForHospital.find(item => item.id === this.selectedTemplate.id);
		//   this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;
		//
		//   // Initialize default placeholder values
		//   let tempCounts = '[MEASUREMENT-COUNT]';
		//   let tempBPMMax = '[BPM-MAX]';
		//   let tempBPMMin = '[BPM-MIN]';
		//   let lastMeasuredDateTime = '[SINCE-DAYS]';
		//
		//   tempCounts = 0;
		//   tempBPMMax = '';
		//   tempBPMMin = '';
		//
		//   if (this.measurementsByDeviceType.length > 0 && this.measurementsByDeviceType[3]) { // for (const deviceType in this.measurementsByDeviceType) {
		//     const { count, extremes, measurements } = this.measurementsByDeviceType[3];
		//     lastMeasuredDateTime = measurements[0].measuredAtLocalTime;
		//     tempCounts = count;
		//     tempBPMMax = extremes.maxValue.readableFormat;
		//     tempBPMMin = extremes.minValue.readableFormat;
		//   }
		//   // }
		//
		//   // Replace placeholders in the template
		//   this.formatedReport = this.formatedReport
		//       .replace('[MEASUREMENT-COUNT]', tempCounts)
		//       .replace('[SINCE-DAYS]', lastMeasuredDateTime)
		//       .replace('[BPM-MAX]', tempBPMMax)
		//       .replace('[BPM-MIN]', tempBPMMin);
		//
		//   // Assign the final report to the medicalNote
		//   this.medicalNote = this.formatedReport;
		// },
		createWeeklyAbnormalReview () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);

			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data && data.measurements.length > 0) {
					thereIsNoData = true;
					const tempCounts = data.count;
					const tempMax = data.extremes.maxValue.readableFormat;
					const tempMin = data.extremes.minValue.readableFormat;
					const lastMeasuredDateTime = data.measurements[0].measuredAtLocalTime;

					const formatted = selectedTemplate.medicalNoteCategoryDescription
						.replace('[DEVICE-MEASUREMENT-UNIT]', this.formatMeasurementName(deviceType))
						.replace('[MEASUREMENT-COUNT]', tempCounts)
						.replace('[SINCE-DAYS]', lastMeasuredDateTime)
						.replace('[MAX]', tempMax)
						.replace('[MIN]', tempMin);

					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}

			this.medicalNote = this.formatedReport;
		},
		createRpmWeeklySummaryBloodPressure () {
			this.formatedReport = '';

			// 1️⃣ Grab your weekly template
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			if (!selectedTemplate) return;

			// 2️⃣ Fetch blood pressure data
			const bpData = this.getMeasurementsByDeviceType(3); // 3 = Blood Pressure monitor
			if (!bpData?.measurements?.length) {
				this.formatedReport = 'No blood pressure data for this week.\n\n';
				this.medicalNote = this.formatedReport;
				return;
			}

			const meas = bpData.measurements;

			// 3️⃣ Compute period range
			const dates = meas.map((m) => new Date(m.measuredAtDate));
			const startObj = new Date(Math.min(...dates));
			const endObj = new Date(Math.max(...dates));
			const fmtDate = (d) => d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
			const startDate = fmtDate(startObj);
			const endDate = fmtDate(endObj);

			// 4️⃣ Basic stats
			const totalReadings = meas.length;
			const uniqueDays = new Set(meas.map((m) => m.measuredAtDate)).size;
			const minBP = bpData.extremes?.minValue?.readableFormat || 'N/A';
			const maxBP = bpData.extremes?.maxValue?.readableFormat || 'N/A';

			// 5️⃣ Time spent (assumed set externally)
			const timeSpent = this.weeklyMinutes || '[TIME-SPENT]';

			// 6️⃣ Medication name(s) from patientObject if available
			const meds = this.patientObject?.medications?.length
				? this.patientObject.medications.map((m) => m.medicationName).join(', ')
				: '—';

			// 7️⃣ Next review date = endDate + 7 days
			const nextDateObj = new Date(endObj);
			nextDateObj.setDate(nextDateObj.getDate() + 7);
			const nextReview = fmtDate(nextDateObj);

			// 8️⃣ Replace placeholders in the template
			this.formatedReport = selectedTemplate.medicalNoteCategoryDescription
				.replace('[DEVICE]', 'Bluetooth-enabled blood pressure monitor (FDA-approved)')
				.replace('[PERIOD-START]', startDate)
				.replace('[PERIOD-END]', endDate)
				.replace('[DAYS-WITH-READINGS]', `${uniqueDays}`)
				.replace('[MEASUREMENT-COUNT]', `${totalReadings}`)
				.replace('[MIN-BLOOD-PRESURE-READINGS]', minBP)
				.replace('[MAX-BLOOD-PRESURE-READINGS]', maxBP)
				.replace('[MEDICATIONS]', meds)
				.replace('[TIME-SPENT]', `${timeSpent} minutes`)
				.replace('[NEXT-REVIEW-DATE]', nextReview);

			this.medicalNote = this.formatedReport;
		},

		createRpmWeeklySummaryBloodSugar () {
			this.formatedReport = '';

			// 1️⃣ Grab your weekly template
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			if (!selectedTemplate) return;

			// 2️⃣ Fetch glucose data
			const glucoseData = this.getMeasurementsByDeviceType(6);
			if (!glucoseData?.measurements?.length) {
				this.formatedReport = 'No glucose data for this week.\n\n';
				this.medicalNote = this.formatedReport;
				return;
			}
			const meas = glucoseData.measurements;

			// 3️⃣ Compute week‐period from measurements
			const dates = meas.map((m) => new Date(m.measuredAtDate));
			const startObj = new Date(Math.min(...dates));
			const endObj = new Date(Math.max(...dates));
			const fmtDate = (d) => d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
			const startDate = fmtDate(startObj);
			const endDate = fmtDate(endObj);

			// 4️⃣ Build data summary & observations
			// detect hypo/hyper
			const lows = meas.filter((m) => m.measuredData.glucose_mgL < 70).length;
			const highs = meas.filter((m) => m.measuredData.glucose_mgL > 300).length;
			let obs = 'Blood glucose readings remain within moderate control range.';
			if (lows || highs) {
				obs = [];
				if (lows) obs.push(`${lows} hypoglycemia episode${lows > 1 ? 's' : ''} (<70 mg/dL)`);
				if (highs) obs.push(`${highs} hyperglycemia episode${highs > 1 ? 's' : ''} (>300 mg/dL)`);
				obs = obs.join(' and ') + ' recorded.';
			}

			// 5️⃣ Time spent (assume you set this.weeklyMinutes somewhere)
			const timeSpent = this.weeklyMinutes || '[TIME-SPENT]';

			// 7️⃣ Next review date = endDate + 7 days
			const nextDateObj = new Date(endObj);
			nextDateObj.setDate(nextDateObj.getDate() + 7);
			const nextReview = fmtDate(nextDateObj);

			// 8️⃣ Replace placeholders in your template
			this.formatedReport = selectedTemplate.medicalNoteCategoryDescription
				.replace('[DEVICE]', 'Bluetooth-enabled glucometer (FDA-approved)')
				.replace('[PERIOD-START]', startDate)
				.replace('[PERIOD-END]', endDate)
				.replace('[DATA-SUMMARY]', obs)
				.replace('[TIME-SPENT]', `${timeSpent} minutes`)
				.replace('[NEXT-REVIEW-DATE]', nextReview);

			this.medicalNote = this.formatedReport;
		},

		createMonthlyReview () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);

			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data && data.measurements.length > 0) {
					thereIsNoData = true;
					const tempCounts = data.count;
					const tempMax = data.extremes.maxValue.readableFormat;
					const tempMin = data.extremes.minValue.readableFormat;
					const lastMeasuredDateTime = data.measurements[0].measuredAtLocalTime;

					const formatted = selectedTemplate.medicalNoteCategoryDescription
						.replace(/\[DEVICE-MEASUREMENT-UNIT\]/g, this.formatMeasurementName(deviceType))
						.replace('[MEASUREMENT-COUNT]', tempCounts)
						.replace('[SINCE-DAYS]', lastMeasuredDateTime)
						.replace('[MAX]', tempMax)
						.replace('[MIN]', tempMin);

					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}

			this.medicalNote = this.formatedReport;
		},

		createRpmMonthlySummaryBloodSugar () {
			this.formatedReport = '';

			// 1️⃣ Grab the time spent
			const timeSpent = this.patientObject.billingData.totalSpentTime;

			// 1️⃣ Grab the template
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			if (!selectedTemplate) return;

			// 2️⃣ Fetch data
			const glucoseData = this.getMeasurementsByDeviceType(6); // Glucose meter
			if (!glucoseData || !glucoseData.measurements?.length) {
				this.formatedReport = 'No glucose data available for this month.\n\n';
				this.medicalNote = this.formatedReport;
				return;
			}
			const measurements = glucoseData.measurements;

			// 3️⃣ Compute stats
			const totalReadings = measurements.length;
			const uniqueDays = new Set(measurements.map((m) => m.measuredAtDate)).size;

			// period start / end
			const allDates = measurements.map((m) => new Date(m.measuredAt));
			const firstDate = new Date(Math.min(...allDates));
			const startOfMonth = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
			const endOfMonth = new Date(firstDate.getFullYear(), firstDate.getMonth() + 1, 0);
			const fmt = (d) => d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
			const startDate = fmt(startOfMonth);
			const endDate = fmt(endOfMonth);

			// fasting average
			const fastingVals = measurements
				.filter((m) => m.measuredData?.isMeasuredBeforeMeal)
				.map((m) => m.measuredData.glucose_mgL);
			const avgFasting = fastingVals.length
				? Math.round(fastingVals.reduce((sum, v) => sum + v, 0) / fastingVals.length)
				: 'N/A';

			// most recent
			const latest = measurements.reduce((a, b) => (new Date(b.measuredAt) > new Date(a.measuredAt) ? b : a));
			const recentValue = `${latest.measuredData.glucose_mgL} mg/dL`;
			const recentDate = fmt(new Date(latest.measuredAt));

			// extremes from API
			const maxVal = glucoseData.extremes.maxValue.readableFormat;
			const minVal = glucoseData.extremes.minValue.readableFormat;

			// hypo / hyper episodes
			const lows = measurements.filter((m) => m.measuredData.glucose_mgL < 70).length;
			const highs = measurements.filter((m) => m.measuredData.glucose_mgL > 300).length;
			const obs =
				!lows && !highs
					? 'No reported episodes of hypoglycemia (<70 mg/dL) or significant hyperglycemia (>300 mg/dL).'
					: [
							lows ? `${lows} hypoglycemia episode${lows > 1 ? 's' : ''}.` : null,
							highs ? `${highs} significant hyperglycemia episode${highs > 1 ? 's' : ''}.` : null,
					  ]
							.filter(Boolean)
							.join(' ');

			// % >160
			const over160 = measurements.filter((m) => m.measuredData.glucose_mgL > 160).length;
			const pctOver160 = Math.round((over160 / totalReadings) * 100);

			// 4️⃣ Prepare placeholders
			const patientName = this.patientName;
			const dob = new Date(this.patientObject.birthDate).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			});

			// 5️⃣ Replace in template
			this.formatedReport = selectedTemplate.medicalNoteCategoryDescription
				.replace('[PATIENT-NAME]', patientName)
				.replace('[DATE-OF-BIRTH]', dob)
				.replace('[START-MONTH-DATE]', startDate)
				.replace('[END-MONTH-DATE]', endDate)
				.replace('[TIME-SPENT-THIS-MONTH] ', timeSpent)
				.replace('[DAYS-WITH-READINGS]', `${uniqueDays}`)
				.replace('[MEASUREMENT-COUNT]', `${totalReadings}`)
				.replace('[AVG-FASTING-GLUCOSE]', `${avgFasting}`)
				.replace('[MAX-GLUCOSE-READINGS]', maxVal)
				.replace('[MIN-GLUCOSE-READINGS]', minVal)
				.replace('[RECENT-GLUCOSE-READING-VALUE]', recentValue)
				.replace('[RECENT-GLUCOSE-READING-DATE]', recentDate)
				.replace('[GLUCOSE-OBSERVATIONS]', obs)
				.replace('[PCT-OVER-160]', `${pctOver160}`);

			this.medicalNote = this.formatedReport;
		},

		createRpmMonthlySummaryBloodPressure () {
			this.formatedReport = '';

			// 1️⃣ Grab the time spent
			const timeSpent = this.patientObject.billingData.totalSpentTime;

			// 2️⃣ Grab the template
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			if (!selectedTemplate) return;

			// 3️⃣ Fetch BP data
			const bpData = this.getMeasurementsByDeviceType(3); // 3 = Blood Pressure Monitor
			if (!bpData || !bpData.measurements?.length) {
				this.formatedReport = 'No blood pressure data available for this month.\n\n';
				this.medicalNote = this.formatedReport;
				return;
			}

			const measurements = bpData.measurements;

			// 4️⃣ Compute stats
			const totalReadings = measurements.length;
			const uniqueDays = new Set(measurements.map((m) => m.measuredAtDate)).size;

			const allDates = measurements.map((m) => new Date(m.measuredAt));
			const firstDate = new Date(Math.min(...allDates));
			const startOfMonth = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
			const endOfMonth = new Date(firstDate.getFullYear(), firstDate.getMonth() + 1, 0);
			const fmt = (d) => d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
			const startDate = fmt(startOfMonth);
			const endDate = fmt(endOfMonth);

			const minBP = bpData.extremes?.minValue?.readableFormat || 'N/A';
			const maxBP = bpData.extremes?.maxValue?.readableFormat || 'N/A';

			const latest = measurements.reduce((a, b) => (new Date(b.measuredAt) > new Date(a.measuredAt) ? b : a));

			const recentValue = `${latest.measuredData.Sys}/${latest.measuredData.Dias} mmHg`;
			const recentDate = fmt(new Date(latest.measuredAt));

			// 5️⃣ Patient info
			const patientName = this.patientName;
			const dob = new Date(this.patientObject.birthDate).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			});

			// 6️⃣ Replace placeholders
			this.formatedReport = selectedTemplate.medicalNoteCategoryDescription
				.replace('[PATIENT NAME]', patientName)
				.replace('[DOB]', dob)
				.replace('[ICD-10 code]', this.selectedDiagnosis?.code || 'I10') // default to I10 if needed
				.replace('[START-MONTH-DATE]', startDate)
				.replace('[END-MONTH-DATE]', endDate)
				.replace('[TIME-SPENT-THIS-MONTH]', timeSpent)
				.replace('[DAYS-WITH-READINGS]', `${uniqueDays}`)
				.replace('[MEASUREMENT-COUNT]', `${totalReadings}`)
				.replace('[MIN-BLOOD-PRESURE-READINGS]', minBP)
				.replace('[MAX-BLOOD-PRESURE-READINGS]', maxBP)
				.replace('[RECENT-BLOOD-PRESURE-READING-VALUE]', recentValue)
				.replace('[RECENT-BLOOD-PRESURE-READING-DATE]', recentDate);

			this.medicalNote = this.formatedReport;
		},

		createFormatReportPhoneComunication () {
			// const selectedTemplate = this.medicalNotesCategoriesForHospital.find(item => item.id === this.selectedTemplate.id);
			const medicalStaffName = this.userData?.firstName + ' ' + this.userData?.lastName;
			const patientName = this.patientName;
			// const durationMinutes = selectedTemplate.billingSecondsForThisMedicalNoteCategory; // You can set default

			const now = new Date();
			const hours = now.getHours().toString().padStart(2, '0');
			const minutes = now.getMinutes().toString().padStart(2, '0');
			const seconds = now.getSeconds().toString().padStart(2, '0');

			// Combine fixed date with current time
			const callStartISO = new Date(`${this.medicalNoteStartDate}T${hours}:${minutes}:${seconds}`).toISOString();
			const startDate = new Date(callStartISO);
			const endDate = new Date(startDate.getTime() + this.secondsToBill * 1000);

			const callDate = startDate.toLocaleDateString('en-US');
			const startTime = startDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
			const endTime = endDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

			this.formatedReport = this.selectedTemplate.medicalNoteCategoryDescription
				.replace('[CALL-DATE]', callDate)
				.replace('[CALL-START-TIME]', startTime)
				.replace('[CALL-END-TIME]', endTime)
				.replace('[CALL-DURATION]', this.intervalInput)
				.replace(/\[MEDICAL-STAFF-NAME\]/g, medicalStaffName)
				.replace('[PATIENT-NAME]', patientName);

			this.medicalNote = this.formatedReport;
		},
		updateCallEndTimeAndDuration () {
			const now = new Date();
			const hours = now.getHours().toString().padStart(2, '0');
			const minutes = now.getMinutes().toString().padStart(2, '0');
			const seconds = now.getSeconds().toString().padStart(2, '0');

			const callStartISO = new Date(`${this.medicalNoteStartDate}T${hours}:${minutes}:${seconds}`).toISOString();
			const startDate = new Date(callStartISO);
			const endDate = new Date(startDate.getTime() + this.secondsToBill * 1000);

			const endTime = endDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
			const newDuration = this.intervalInput;

			// Replace only the End Time and Duration in the note
			this.medicalNote = this.medicalNote
				.replace(/(End Time: ).*/, `$1${endTime}`)
				.replace(/(Duration: ).*/, `$1${newDuration} minutes`);
		},
		createMonthlyReviewOld () {
			this.formatedReport = '';

			// Find the selected template
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;

			// Initialize default placeholder values
			let tempCounts = '[MEASUREMENT-COUNT]';
			let tempBPMMax = '[BPM-MAX]';
			let tempBPMMin = '[BPM-MIN]';
			let lastMeasuredDateTime = '[SINCE-DAYS]';

			tempCounts = 0;
			tempBPMMax = '';
			tempBPMMin = '';

			if (this.measurementsByDeviceType.length > 0 && this.measurementsByDeviceType[3]) {
				// for (const deviceType in this.measurementsByDeviceType) {
				const { count, extremes, measurements } = this.measurementsByDeviceType[3];
				lastMeasuredDateTime = measurements[0].measuredAtLocalTime;
				tempCounts = count;
				tempBPMMax = extremes.maxValue.readableFormat;
				tempBPMMin = extremes.minValue.readableFormat;
			}
			// }

			// Replace placeholders in the template
			this.formatedReport = this.formatedReport
				.replace('[MEASUREMENT-COUNT]', tempCounts)
				.replace('[SINCE-DAYS]', lastMeasuredDateTime)
				.replace('[BPM-MAX]', tempBPMMax)
				.replace('[BPM-MIN]', tempBPMMin);

			// Assign the final report to the medicalNote
			this.medicalNote = this.formatedReport;
		},
		createNewToRpmReview () {
			this.formatedReport = '';

			// Find the selected template
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;

			// Initialize default placeholder values
			let tempCounts = '[MEASUREMENT-COUNT]';
			let tempBPMMax = '[BPM-MAX]';
			let tempBPMMin = '[BPM-MIN]';
			let firstMeasuredDateTime = '[FIRST-DATE]';

			tempCounts = 0;
			tempBPMMax = '';
			tempBPMMin = '';

			if (this.measurementsByDeviceType.length > 0 && this.measurementsByDeviceType[3]) {
				// for (const deviceType in this.measurementsByDeviceType) {
				const { count, extremes, measurements } = this.measurementsByDeviceType[3];
				firstMeasuredDateTime = measurements[measurements.length - 1].measuredAtLocalTime;
				tempCounts = count;
				tempBPMMax = extremes.maxValue.readableFormat;
				tempBPMMin = extremes.minValue.readableFormat;
			}
			// }

			// Replace placeholders in the template
			this.formatedReport = this.formatedReport
				.replace('[MEASUREMENT-COUNT]', tempCounts)
				.replace('[FIRST-DATE]', firstMeasuredDateTime)
				.replace('[BPM-MAX]', tempBPMMax)
				.replace('[BPM-MIN]', tempBPMMin);

			// Assign the final report to the medicalNote
			this.medicalNote = this.formatedReport;
		},
		thirdPartyReport () {
			this.formatedReport = '';
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);

			const deviceTypes = [1, 2, 3, 5, 6]; // Temperature, Oximeter, BP, Weight, Glucose
			let thereIsNoData = false;
			deviceTypes.forEach((deviceType) => {
				const data = this.getMeasurementsByDeviceType(deviceType);
				if (data && data.measurements.length > 0) {
					thereIsNoData = true;
					const formatted = selectedTemplate.medicalNoteCategoryDescription.replace(
						/\[DEVICE-MEASUREMENT-UNIT\]/g,
						this.formatMeasurementName(deviceType),
					);
					this.formatedReport += formatted + '\n\n';
				}
			});
			if (!thereIsNoData) {
				const formatted = selectedTemplate.medicalNoteCategoryDescription;
				this.formatedReport = formatted + '\n\n';
			}

			this.medicalNote = this.formatedReport;
		},
		createFormatReportWithoutArguments () {
			this.formatedReport = '';
			// Compile data for each measurement in text form
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;
			this.medicalNote = this.formatedReport;
		},
		generateReport (startDate, endDate, medicalNoteCategoryType) {
			this.formatedReport = '';
			// eslint-disable-next-line no-unused-vars
			let filteredData = [];
			// Iterate over each object in assignedMedicalDevicesList array
			filteredData = this.hubs.assignedMedicalDevicesList.map((device) => {
				const filteredMeasurements = device.measurementsData
					.filter((measurement) => {
						// Check if the measuredAtDate is within the date range
						const measuredDate = new Date(measurement.measuredAtDate.slice(0, 10));
						const start = new Date(startDate);
						const end = new Date(endDate);
						return measuredDate >= start && measuredDate <= end;
					})
					.sort((a, b) => {
						// Convert measuredAtDate strings to Date objects for comparison
						const dateA = new Date(a.measuredAtDate);
						const dateB = new Date(b.measuredAtDate);
						// Sort in descending order based on measuredAtDate
						return dateB - dateA;
					});
				// Parse the measuredDataJson field for each measurement
				filteredMeasurements.forEach((measurement) => {
					measurement.measuredData = JSON.parse(measurement.measuredDataJson);

					// This line causing problem
					// delete measurement.measuredDataJson;

					measurement.measuredAtLocalTime = new Date(measurement.measuredAtUtc).toLocaleString('en-US', {
						month: 'short',
						day: 'numeric',
						year: 'numeric',
						hour: 'numeric',
						minute: 'numeric',
						hour12: true,
					});
					// Find the deviceDefaultExtremeValuesJson and deviceDefaultValuesJson for the corresponding deviceType
					const matchingDevice = this.hubs.assignedMedicalDevicesList.find(
						(d) => d.deviceType === measurement.deviceType,
					);
					if (matchingDevice) {
						measurement.deviceDefaultExtremeValues = JSON.parse(matchingDevice.deviceDefaultExtremeValuesJson);
						measurement.deviceDefaultValues = JSON.parse(matchingDevice.deviceDefaultValuesJson);
						measurement.deviceName = matchingDevice.deviceName;
						measurement.deviceType = matchingDevice.deviceType;
						measurement.isAbnormal = false;
					}
				});

				// Return the device object with filtered measurementsData
				return {
					deviceName: device.deviceName,
					measurementsData: filteredMeasurements,
				};
			});

			// Merge measurementsData from all devices into one array
			const mergedMeasurements = filteredData.reduce((merged, device) => {
				merged.push(...device.measurementsData);
				return merged;
			}, []);

			// Aggregate measurements by deviceType and count the number of measurements
			this.measurementsByDeviceType = mergedMeasurements.reduce((agg, measurement) => {
				const deviceType = measurement.deviceType;
				if (!agg[deviceType]) {
					agg[deviceType] = {
						deviceName: measurement.deviceName,
						deviceType: measurement.deviceType,
						count: 0,
						extremes: {
							minValue: {
								value: 0,
								readableFormat: '',
								measuredAtUTC: null,
								measuredAtLocalTime: null,
							},
							maxValue: {
								value: 0,
								readableFormat: '',
								measuredAtUTC: null,
								measuredAtLocalTime: null,
							},
						},
						measurements: [],
					};
				}
				agg[deviceType].count++;
				agg[deviceType].measurements.push(measurement);
				return agg;
			}, []);

			this.findMinAndMax();
		},
		formatDateToUS (date) {
			// Split the ISO date into its components
			const [year, month, day] = date.split('-');
			// Rearrange the components to match the US format (MM/DD/YYYY)
			return `${month}/${day}/${year}`;
		},
		firstDayOfCurrentWeek () {
			const tempDate = new Date(this.calendarDate.toString());
			const dayOfWeek = tempDate.getDay();
			const diff = tempDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
			tempDate.setDate(diff);
			return tempDate.toISOString().slice(0, 10);
		},
		lastDayOfCurrentWeek () {
			const tempDate = new Date(this.calendarDate.toString());
			const dayOfWeek = tempDate.getDay();
			const diff = tempDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1) + 6;
			tempDate.setDate(diff);
			return tempDate.toISOString().slice(0, 10);
		},
		firstDayOfSelectedMonth () {
			const tempDate = new Date(this.calendarDate.toString());
			tempDate.setDate(1); // Set the date to the 1st of the current month
			return tempDate.toISOString().slice(0, 10); // Return the date in YYYY-MM-DD format
		},
		getMonthAndYear () {
			const [year, month] = this.selectedDate.split('-');

			return {
				month: parseInt(month),
				year: parseInt(year),
			};
		},
		formatMeasurementName (deviceType) {
			switch (parseInt(deviceType)) {
				case 1:
					return this.$t('temperature');
				case 2:
					return this.$t('oximetry');
				case 3:
					return this.$t('bloodPressure');
				case 5:
					return this.$t('weight');
				case 6:
					return this.$t('glucometry');
				default:
					return '';
			}
		},
		createDailyReviewWithMeasurements () {
			this.formatedReport = '';

			this.formatedReport = 'Daily review of BP completed, reading today WNL:';
			// Compile data for each measurement in text form
			if (this.measurementsByDeviceType.length > 0 && this.measurementsByDeviceType[3]) {
				for (const deviceType in this.measurementsByDeviceType) {
					const { count } = this.measurementsByDeviceType[deviceType];
					this.formatedReport += `(${count}) `;
				}
			} else {
				this.formatedReport += '0 ';
			}
			this.formatedReport += 'Will continue to monitor trends and update PCP as needed.';
			this.medicalNote = this.formatedReport;
		},
		getTemplateDescription (val) {
			this.billingsSecondsTextFieldVisible = true;
			this.selectedMedicalNoteCategory = this.medicalNotesCategoriesForHospital.find((item) => item.id === val.id);

			this.composeReport(val);
			// // this.medicalNote = selectedTemplate?.medicalNoteCategoryDescription;
			// this.selectedTemplateId = selectedTemplate.id;
			// this.billingSecondsForThisMedicalNoteCategory = selectedTemplate.billingSecondsForThisMedicalNoteCategory;
			// this.medicalNoteCategoryName = selectedTemplate.medicalNoteCategoryName;
		},
		dateSelected (val) {
			if (this.selectedTemplate === null || this.selectedTemplate === undefined) {
				return;
			}
			this.composeReport(this.selectedTemplate);
		},
		createFormatReportWithMeasurements () {
			this.formatedReport = '';
			// Compile data for each measurement in text form
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;
			if (this.measurementsByDeviceType.length > 0) {
				for (const deviceType in this.measurementsByDeviceType) {
					const { count, extremes, measurements } = this.measurementsByDeviceType[deviceType];
					this.formatedReport += `${this.formatMeasurementName(deviceType)}: `;
					this.formatedReport += `counts:(${count}) `;
					this.formatedReport += `max: ${extremes.maxValue.readableFormat} `;
					this.formatedReport += `min: ${extremes.minValue.readableFormat}\n`;
					measurements.forEach((measurement, index) => {
						this.formatedReport += `${index + 1}. `;
						this.formatedReport += `${measurement.measuredAtLocalTime} `;
						this.formatedReport += `measured: ${this.formatMeasurement(
							measurement.measuredData,
							measurement.deviceDefaultValues,
						)}\n`;
					});
					this.formatedReport += '\n';
				}
			} else {
				this.formatedReport += 'There are no readings for this patient\n';
			}
			this.medicalNote = this.formatedReport;
		},
		createFormatReportWithoutMeasurements () {
			this.formatedReport = '';
			// Compile data for each measurement in text form
			const selectedTemplate = this.medicalNotesCategoriesForHospital.find(
				(item) => item.id === this.selectedTemplate.id,
			);
			this.formatedReport = `${selectedTemplate.medicalNoteCategoryDescription}\n\n`;
			this.medicalNote = this.formatedReport;
		},
		getAllMedicalStaff () {
			this.$store.dispatch('hospitals/getRelatedMedicalStaff', this.userData.hospitalAssignedData.id);
		},
		formatDateUsingLocalesFromUTC (dateTime) {
			return new Date(dateTime).toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			});
		},
		delayExecution (timeDelay) {
			setTimeout(() => {
				this.toggleHeaders();
			}, timeDelay); // 500 milliseconds = 0.5 seconds
		},
		toggleHeaders () {
			const table = this.$refs.table;
			if (table) {
				const openCache = table?.$vnode.componentInstance.openCache;
				if (openCache) {
					Object.keys(openCache).forEach((group) => {
						this.$set(openCache, group, false);
					});
				}
			}
		},
		formatContent (content) {
			return content.replace(/\n/g, '<br>');
		},
		medicalStaffName (staffId) {
			if (this.medicalStaff && this.medicalStaff.length > 0) {
				const matchedStaff = this.medicalStaff.find((staff) => staff.id === staffId);
				if (matchedStaff) {
					return `${matchedStaff.firstName} ${matchedStaff.lastName}`;
				}
			}
			return '';
		},
		formatDate (val) {
			// Parse the input date string
			const dateObject = new Date(val);
			// Format the date as "Month Day Year"
			return dateObject.toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			});
		},
		getDeviceNames (device) {
			switch (device.deviceType) {
				case 5:
					return this.$t('weight-scale');
				case 3:
					return this.$t('blood-pressure');
				case 2:
					return this.$t('oximeter');
				case 1:
					return this.$t('thermometer');
				case 6:
					return this.$t('glucose-meter');
			}
		},
		async sendToMedicalNote () {
			const totalTime = new Date().getTime() - this.startTime;
			const payloadBody = {
				medicalNoteName:
					this.selectedMedicalNoteCategory.medicalNoteCategoryName + ': ' + this.medicalNoteNameAdditionalData,
				// medicalNotesCategories: this.medicalNotesCategoriesForHospital,
				// allowToBeEditedFromOthers: false,
				// allowToBeCommentedFromOthers: false,
				medicalNoteCategoryId: this.selectedMedicalNoteCategory.id,
				medicalNoteOfficeId: localStorage.getItem('selectedHospitalAssignedId'),
				createdByMedicalStaffId: this.userData.id,
				medicalNoteForPatientId: this.patientId,
				medicalNoteStartDate: this.medicalNoteStartDate,
				medicalNoteEndDate: this.medicalNoteEndDate,
				allowToBeEditedFromOthers: this.editedFromOthers,
				allowToBeCommentedFromOthers: this.commentedFromOthers,
				// secondsToBill: this.secondsToBill,
				secondsToBill: Math.floor(totalTime / 1000),
				medicalNoteDetail: {
					// medicalNoteId: 0,
					// billingSecondsForThisMedicalNoteDetail: this.selectedMedicalNoteCategory.billingSecondsForThisMedicalNoteCategory,
					medicalStaffId: this.userData.id,
					medicalNoteContent: this.medicalNote,
					medicalNoteAdditionalData: '',
				},
			};
			await this.$store.dispatch('appointments/medicalNoteWithCustomSeconds', payloadBody).then((res) => {
				this.closeDialog(true);
			});
		},
		async sendToCCMMedicalNote () {
			const payloadBody = {
				medicalNoteName:
					this.selectedMedicalNoteCategory.medicalNoteCategoryName + ': ' + this.medicalNoteNameAdditionalData,
				medicalNoteCategoryId: this.selectedMedicalNoteCategory.id,
				medicalNoteOfficeId: localStorage.getItem('selectedHospitalAssignedId'),
				createdByMedicalStaffId: this.userData.id,
				medicalNoteForPatientId: this.patientId,
				medicalNoteStartDate: this.medicalNoteStartDate,
				medicalNoteEndDate: this.medicalNoteEndDate,
				allowToBeEditedFromOthers: this.editedFromOthers,
				allowToBeCommentedFromOthers: this.commentedFromOthers,
				secondsToBill: this.secondsToBill,
				medicalNoteDetails: [
					{
						medicalStaffId: this.userData.id,
						medicalNoteContent: this.medicalNote,
						medicalNoteAdditionalData: '',
					},
				],
			};
			const body = {
				ccmRecordId: this.selectedCCMRecord.id,
				patientId: this.selectedCCMRecord.patientId,
				hospitalId: this.selectedCCMRecord.hospitalId,
				noteDate: new Date().toISOString(),
				noteTitle: this.selectedMedicalNoteCategory.medicalNoteCategoryName + ': ' + this.medicalNoteNameAdditionalData,
				noteContent: this.medicalNote,
				medicalNoteType: this.selectedMedicalNoteCategory.medicalNoteCategoryType,
				performedBy: this.userData.firstName + ' ' + this.userData.lastName,
				role: '',
				staffId: this.userData.id,
				timeSpentSeconds: this.secondsToBill,
				additionalData: JSON.stringify(payloadBody),
			};

			try {
				this.$store.dispatch('ccmMedicalNote/addCCMMedicalNote', body);
			} catch (error) {
				// Change this to something more suitable
				this.$store.commit('alerts/add', {
					id: 'addedMedicalNote',
					type: 'error',
					color: 'main_red',
					message: this.$t('failed!'),
				});
			} finally {
				this.$store
					.dispatch('ccmMedicalNote/getCCMMedicalNoteByPatientId', this.selectedCCMRecord.patientId)
					.then((res) => {
						this.closeDialog(true);
					});
			}
		},
		async synchronizeDrawersV2 () {
			if (this.selectedCCMRecord !== null) {
				this.sendToCCMMedicalNote();
			} else {
				this.sendToMedicalNote();
			}
		},
		getDeviceDefaults (deviceType) {
			return this.deviceDefaultsValues.find((device) => device.deviceType === deviceType);
		},
		formatMeasurement (data) {
			// const data = JSON.parse(values);
			var deviceDefaults = JSON.parse(this.getDeviceDefaults(parseInt(data.device_type)).deviceDefaultValuesJson);
			var isAbnormal = false;
			switch (parseInt(data.device_type)) {
				case 1:
					isAbnormal = false;
					if (
						data?.Temperature_C > deviceDefaults.MaxTemperature ||
						data?.Temperature_C < deviceDefaults.MinTemperature
					) {
						isAbnormal = true;
					} else {
						isAbnormal = false;
					}

					if (this.userSettings.Units.toLowerCase() === 'metric') {
						if (isAbnormal) {
							return data?.Temperature_C + ' °C (Abnormal)';
						} else {
							return data?.Temperature_C + ' °C (Normal)';
						}
					} else if (this.userSettings.Units.toLowerCase() === 'imperial') {
						if (isAbnormal) {
							return data?.Temperature_F + ' °F (Abnormal)';
						} else {
							return data?.Temperature_F + ' °F (Normal)';
						}
					}
					break;
				case 3:
					isAbnormal = false;

					var systolicChecking = data?.Sys > deviceDefaults.SystolicMax || data?.Sys < deviceDefaults.SystolicMin;
					var diastolicChecking = data?.Dias > deviceDefaults.DiastolicMax || data?.Dias < deviceDefaults.DiastolicMin;
					var heartBeatChecking = data?.Pul > deviceDefaults.HeartBeatMax || data?.Pul < deviceDefaults.HeartBeatMin;

					if (systolicChecking || diastolicChecking || heartBeatChecking) {
						isAbnormal = true;
						return data?.Sys + '/' + data?.Dias + ' mmHg (Abnormal)';
					} else {
						isAbnormal = false;
						return data?.Sys + '/' + data?.Dias + ' mmHg (Normal)';
					}

				case 2:
					isAbnormal = false;

					if (data?.Spo2 < deviceDefaults.SpO2) {
						isAbnormal = true;
						return data?.Spo2 + '% (Abnormal)';
					} else {
						isAbnormal = false;
						return data?.Spo2 + '% (Normal)';
					}
				case 5:
					if (this.userSettings.Units.toLowerCase() === 'metric') {
						return data.weight_kg + ' kg';
					} else return data.weight_lbs + ' lb';
				case 6:
					//  isMeasuredBeforeMeal
					isAbnormal = false;

					var glucoseChecking =
						data?.glucose_mmolL > deviceDefaults.BloodSugarLevelMax ||
						data?.glucose_mmolL < deviceDefaults.BloodSugarLevelMin;
					if (glucoseChecking) {
						isAbnormal = true;
					} else {
						isAbnormal = false;
					}

					if (isAbnormal) {
						if (this.userSettings.Concentration.toLowerCase() === 'mmol/l') {
							return parseFloat(data.glucose_mmolL).toFixed(1) + ' mmol/L (Abnormal)';
						} else return parseFloat(data.glucose_mgL).toFixed(1) + ' mg/dL (Abnormal)';
					} else {
						if (this.userSettings.Concentration.toLowerCase() === 'mmol/l') {
							return parseFloat(data.glucose_mmolL).toFixed(1) + ' mmol/L (Normal)';
						} else return parseFloat(data.glucose_mgL).toFixed(1) + ' mg/dL (Normal)';
					}
				case 7:
					if (this.userSettings.Concentration.toLowerCase() === 'mmol/l') {
						return parseFloat(data.cholesterol_mmolL).toFixed(1) + ' mmol/L';
					} else return parseFloat(data.cholesterol_mgL).toFixed(1) + ' mg/dL';
			}
		},
		findMinAndMax () {
			this.measurementsByDeviceType.forEach((deviceMeasurements) => {
				const tempExtremes = {
					minValue: {
						value: Infinity,
						readableFormat: '',
						measuredAtUTC: null,
						measuredAtLocalTime: null,
					},
					maxValue: {
						value: -Infinity,
						readableFormat: '',
						measuredAtUTC: null,
						measuredAtLocalTime: null,
					},
				};

				deviceMeasurements.measurements.forEach((measurement) => {
					const { deviceType, measuredData, measuredAtUtc, measuredAtLocalTime } = measurement;
					var range = measurement.deviceDefaultValues;

					switch (parseInt(deviceType)) {
						case 1: // Temperature device
							// eslint-disable-next-line no-case-declarations
							const tempValue =
								this.userSettings.Units.toLowerCase() === 'metric'
									? measuredData.Temperature_C
									: measuredData.Temperature_F;
							// eslint-disable-next-line no-case-declarations
							const tempUnit = this.userSettings.Units.toLowerCase() === 'metric' ? '°C' : '°F';

							if (
								measuredData.Temperature_C > range.MaxTemperature ||
								measuredData.Temperature_C < range.MinTemperature
							) {
								measuredData.isAbnormal = true;
								measurement.isAbnormal = true;
							} else {
								measuredData.isAbnormal = false;
								measurement.isAbnormal = false;
							}

							if (measuredData.Temperature_C < tempExtremes.minValue.value) {
								tempExtremes.minValue = {
									value: tempValue,
									readableFormat: tempValue + tempUnit,
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}

							if (measuredData.Temperature_C > tempExtremes.maxValue.value) {
								tempExtremes.maxValue = {
									value: tempValue,
									readableFormat: tempValue + tempUnit,
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}
							break;

						case 2: // SPO2 device
							if (measuredData.Spo2 < range.SpO2) {
								measuredData.isAbnormal = true;
								measurement.isAbnormal = true;
							} else {
								measuredData.isAbnormal = false;
								measurement.isAbnormal = false;
							}

							if (measuredData.Spo2 < tempExtremes.minValue.value) {
								tempExtremes.minValue = {
									value: measuredData.Spo2,
									readableFormat: measuredData.Spo2 + '%',
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}

							if (measuredData.Spo2 > tempExtremes.maxValue.value) {
								tempExtremes.maxValue = {
									value: measuredData.Spo2,
									readableFormat: measuredData.Spo2 + '%',
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}
							break;

						case 3: // Blood pressure device (Sys)
							var systolicChecking = measuredData.Sys > range.SystolicMax || measuredData.Sys < range.SystolicMin;
							var diastolicChecking = measuredData.Dias > range.DiastolicMax || measuredData.Dias < range.DiastolicMin;
							var heartBeatChecking = measuredData.Pul > range.HeartBeatMax || measuredData.Pul < range.HeartBeatMin;
							if (systolicChecking || diastolicChecking || heartBeatChecking) {
								measuredData.isAbnormal = true;
								measurement.isAbnormal = true;
							} else {
								measuredData.isAbnormal = false;
								measurement.isAbnormal = false;
							}
							if (measuredData.Sys < tempExtremes.minValue.value) {
								tempExtremes.minValue = {
									value: measuredData.Sys,
									readableFormat: measuredData.Sys + '/' + measuredData.Dias + 'mmHg',
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}

							if (measuredData.Sys > tempExtremes.maxValue.value) {
								tempExtremes.maxValue = {
									value: measuredData.Sys,
									readableFormat: measuredData.Sys + '/' + measuredData.Dias + 'mmHg',
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}
							break;
						case 5: // Weight scale
							measuredData.isAbnormal = false;
							measurement.isAbnormal = false;
							// eslint-disable-next-line no-case-declarations
							const scaleValue =
								this.userSettings.Units.toLowerCase() === 'metric' ? measuredData.weight_kg : measuredData.weight_lbs;
							// eslint-disable-next-line no-case-declarations
							const scaleUnit = this.userSettings.Units.toLowerCase() === 'metric' ? 'Kg' : 'lbs';

							if (scaleValue < tempExtremes.minValue.value) {
								tempExtremes.minValue = {
									value: scaleValue,
									readableFormat: scaleValue + scaleUnit,
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}

							if (scaleValue > tempExtremes.maxValue.value) {
								tempExtremes.maxValue = {
									value: scaleValue,
									readableFormat: scaleValue + scaleUnit,
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}
							break;

						case 6: // Blood sugar
							// eslint-disable-next-line no-case-declarations
							const bloodSugarValue =
								this.userSettings.Concentration.toLowerCase() === 'mmol/l'
									? measuredData.glucose_mmolL
									: measuredData.glucose_mgL;
							// eslint-disable-next-line no-case-declarations
							const bloodSugarUnit = this.userSettings.Concentration.toLowerCase() === 'mmol/l' ? 'mmol/L' : 'mg/dL';

							var glucoseChecking =
								measuredData.glucose_mmolL > range.BloodSugarLevelMax ||
								measuredData.glucose_mmolL < range.BloodSugarLevelMin;
							if (glucoseChecking) {
								measuredData.isAbnormal = true;
								measurement.isAbnormal = true;
							} else {
								measuredData.isAbnormal = false;
								measurement.isAbnormal = false;
							}

							if (bloodSugarValue < tempExtremes.minValue.value) {
								tempExtremes.minValue = {
									value: bloodSugarValue.toFixed(1),
									readableFormat: bloodSugarValue.toFixed(1) + bloodSugarUnit,
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}

							if (bloodSugarValue > tempExtremes.maxValue.value) {
								tempExtremes.maxValue = {
									value: bloodSugarValue.toFixed(1),
									readableFormat: bloodSugarValue.toFixed(1) + bloodSugarUnit,
									measuredAtUTC: measuredAtUtc,
									measuredAtLocalTime: measuredAtLocalTime,
								};
							}
							break;

						default:
							// Handle any other device types if necessary
							break;
					}
				});
				// Assign the computed tempExtremes to the extremes property of the current deviceMeasurements
				deviceMeasurements.extremes = tempExtremes;
			});
		},
		closeDialog (withNote = false) {
			if (withNote === false) {
				const totalTime = new Date().getTime() - this.startTime;
				if (
					(this.userData.roleData.roleName === 'DOCTOR' || this.userData.roleData.roleName === 'NURSE') &&
					this.userData.isSequoiaUser
				) {
					const body = {
						hospitalId: Number(localStorage.getItem('selectedHospitalAssignedId')), // get selected hospital, if there are more assigned to the user
						patientId: this.patientId,
						staffId: this.userData.id,
						visitedPageUrl: 'WEB:' + this.$route.name,
						timeSpentSeconds: Math.floor(totalTime / 1000),
					};
					this.stopTrackingWithPatientV2(body);
				}
			}
			this.selectedTemplate = null;
			this.medicalNote = '';
			this.intervalInput = '';
			this.billingsSecondsTextFieldVisible = false;
			this.$emit('reload-medical-notes');
			// this.$emit('update:show', false);
			this.$store.commit('SET_TOGGLE_REVIEW_DIALOG', false);
		},

		async loadVitalEntries () {
			if (this.patientObject.patientId) {
				const date = new Date(this.selectedDate);
				const response = await this.getCCMVitalEntriesByPatientIdByMonthByYear({
					patientId: this.patientObject.patientId,
					month: date.getMonth() + 1,
					year: date.getFullYear(),
				});

				this.ccmVitalsByMonthByYearResponse = response.data.map((r) => {
					const outputValue = getValueByUnit(
						r.value,
						r.vitalType === 'Blood Glucose' ? '' : this.userSettings.Units,
						r.vitalType === 'Blood Glucose' ? this.userSettings.Concentration : '',
					);
					return {
						vitalType: r.vitalType,
						value: r.value,
						valueFormatted: outputValue.value,
						unitFormatted: outputValue.unit,
						vitalDate: r.vitalDate,
						notes: r.notes,
						performedBy: r.performedBy,
						referenceId: r.referenceId,
						hospitalName: r.hospitalName,
						patientName: r.patientName,
						dataSupplyProviderName: r.dataSupplyProviderName,
						id: r.id,
						createMedicalNoteForThisVital: r.createMedicalNoteForThisVital,
					};
				});

				this.ccmVitalsByMonthByYear = this.ccmVitalsByMonthByYearResponse;
			}
		},
		calcMeasurementsTableHeight () {
			this.$nextTick(() => {
				this.measurementsTableHeight = this.$refs.measurementsTable.clientHeight - 68;
			});
		},
		calcTextAreaHeight () {
			this.$nextTick(() => {
				this.textAreaHeight =
					this.$refs.notesCard.clientHeight -
					this.$refs.templateSelect.clientHeight -
					this.$refs.billingsTimeSelect.clientHeight -
					this.$refs.commentEditToggle.clientHeight -
					this.$refs.saveButton.clientHeight -
					32;
			});
		},
	},
};
</script>
<style>
.red-hint .v-messages__message {
	color: red !important;
	line-height: 1.8;
}
</style>
